module.exports = __webpack_public_path__ + "img/bg_festa8.ee880733.jpg";